import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import DataTable from './shared/DataTable';
import 'moment-timezone';
import { observer } from "mobx-react";

const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
  },
});

class Terms extends Component {

  constructor(props) {
    super(props);
    this._validAuthStates = ['signedIn'];
    
    this.handleSearchInputChange = this.handleSearchInputChange.bind(this);
  }

  componentDidMount() {
    this.props.termsStore.getTermsList();
  }

  addTerms() {
    this.props.termsStore.addTerms();
  }

  componentWillUnmount() {
    clearTimeout(this.searchTimeout);
  }

  handleSearchInputChange(event) {
    this.props.termsStore.searchTerm = event.target.value;

    /* Only search once the user stops typing */
    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => this.props.termsStore.searchTerms(), 300);
  }
  
  render() {
    const { classes } = this.props;

    return (
      <Grid container>
        <Grid item >
          <TextField
              id="searchTerm"
              name="searchTerm"
              label="Suchbegriff"
              type="search"
              className={classes.textField}
              margin="none"
              value={this.props.termsStore.searchTerm}
              onChange={this.handleSearchInputChange} />
        </Grid>
        <Grid item>
          <Button variant="contained" size="small" color="secondary" onClick={()=>this.addTerms()} className={classes.button}>
            AGB &amp; Datenschutz anlegen
          </Button>
        </Grid>
        <DataTable 
          store={this.props.termsStore} 
          rows={this.props.termsStore.termsList} 
          columns={this.props.termsStore.tableColumns}
          history={this.props.history}
        />
      </Grid>
    );
  }
}

export default withStyles(styles)(observer(Terms));
